import { gql } from '@apollo/client';

export const CREATE_BILLING_CHECKOUT_SESSION = gql`
  mutation CreateBillingCheckoutSession($priceId: String!, $successUrl: String!, $cancelUrl: String!) {
    createBillingCheckoutSession(priceId: $priceId, successUrl: $successUrl, cancelUrl: $cancelUrl) {
      url
      sessionId
    }
  }
`;

export const CREATE_BILLING_PORTAL_SESSION = gql`
  mutation CreateBillingPortalSession($returnUrl: String!) {
    createBillingPortalSession(returnUrl: $returnUrl) {
      url
      sessionId
    }
  }
`;

export interface BillingSession {
  url?: string | null;
  sessionId?: string | null;
}

export interface CreateBillingCheckoutSessionData {
  createBillingCheckoutSession?: BillingSession | null;
}

export interface CreateBillingCheckoutSessionVars {
  priceId: string;
  successUrl: string;
  cancelUrl: string;
}

export interface CreateBillingPortalSessionData {
  createBillingPortalSession?: BillingSession | null;
}

export interface CreateBillingPortalSessionVars {
  returnUrl: string;
}
